export var Action;
(function (Action) {
    Action["INFO"] = "info";
    Action["CART"] = "cart";
    Action["CONFIGURATE"] = "configurate";
    Action["SAVE"] = "save";
})(Action || (Action = {}));
